import { render, staticRenderFns } from "./generic_brick_wrapper.vue?vue&type=template&id=66ce3668&scoped=true&"
import script from "./generic_brick_wrapper.vue?vue&type=script&lang=js&"
export * from "./generic_brick_wrapper.vue?vue&type=script&lang=js&"
import style0 from "./generic_brick_wrapper.vue?vue&type=style&index=0&id=66ce3668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce3668",
  null
  
)

/* custom blocks */
import block0 from "./generic_brick_wrapper.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports